import React from "react";
import { useNavigate } from "react-router-dom";
import { useIntegrations } from "./../hooks/useIntegrations";
import {
    Shield,
    ExternalLink,
} from "lucide-react";

import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { MobileHeader } from "./MobileHeader";

// const connectedIntegration = {
//     name: "PetPooja",
//     connectedDate: "May 10, 2025",
//     status: "Connected",
//     logo:
//         "https://firebasestorage.googleapis.com/v0/b/loyaltea-46e52.firebasestorage.app/o/assets%2FPetPoojaLogo.png?alt=media&token=98c05fae-5a92-434d-9d95-f466210cb2e6",
// };

// const availableIntegration = {
//     name: "Shopify",
//     description:
//         "Integrate your Shopify store to automatically show offers to your customers.",
//     logo:
//         "https://firebasestorage.googleapis.com/v0/b/loyaltea-46e52.firebasestorage.app/o/assets%2FShopify-Logo.jpg?alt=media&token=938b2bc4-f900-44de-8b03-d67d94d3f364",
// };

function IntegrationCard({
    integration,
    connected = false,
}) {

    const navigate = useNavigate();

    function handleClick() {

        if (connected) {
            // TODO: Navigate to integration management page
            return;
        }

        if (integration.key === "shopify") {

            navigate("/setup/integrations/shopify");

        } else if (integration.key === "petpooja") {

            navigate("/setup/integrations/petpooja");

        }

    }

    return (

        <div className="integration-card">

            <div className="integration-left">

                <img
                    src={integration.logo}
                    alt={integration.name}
                    className="integration-logo"
                />

                <div>

                    <div className="integration-title-row">

                        <h3>

                            {integration.name}

                        </h3>

                        {connected && (
                            <span className="status-badge active">

                                Connected

                            </span>
                        )}

                    </div>

                    <p className="integration-description">

                        {integration.description}

                    </p>

                    {connected && (

                        <p className="integration-date">

                            Connected on {integration.connectedDate}

                        </p>

                    )}

                </div>

            </div>

            <div className="integration-right">

                <button
                    className={
                        connected
                            ? "secondary-btn"
                            : "primary-btn"
                    }
                    onClick={handleClick}
                >

                    {connected ? "Manage" : "Connect"}

                </button>

            </div>

        </div>

    );

}

export function Integrations() {
    const {
        data,
        isLoading,
        error,
    } = useIntegrations();

    if (isLoading) {
        return (

            <div className="page-state">

                <div className="page-state-spinner" />

                <h2>

                    Loading...

                </h2>

                <p>

                    We're fetching your latest data.

                </p>

            </div>

        );
    }

    if (error) {
        return (

            <div className="page-state">

                <div className="page-state-icon">

                    !

                </div>

                <h2>

                    Something went wrong

                </h2>

                <p>

                    We couldn't load this page. Please try refreshing or come back in a moment.

                </p>

                <button

                    className="primary-btn"

                    onClick={() => window.location.reload()}

                >

                    Try Again

                </button>

            </div>

        );
    }

    const integrations = [

        {
            key: "petpooja",
            name: "PetPooja",
            logo: "https://firebasestorage.googleapis.com/v0/b/loyaltea-46e52.firebasestorage.app/o/assets%2Fpetpooja-small-logo.png?alt=media&token=8bbef549-7ec2-4476-864a-5ef6aa44d367",
            description: "Integrate your PetPooja POS to automatically issue and redeem offers.",
            ...data.petpooja,
        },

        {
            key: "shopify",
            name: "Shopify",
            logo: "https://firebasestorage.googleapis.com/v0/b/loyaltea-46e52.firebasestorage.app/o/assets%2Fshopify-small-logo.png?alt=media&token=ebb6ffe0-8b64-491f-a2c9-307dd3cb1f52",
            description: "Integrate your Shopify store to automatically show offers to your customers.",
            ...data.shopify,
        },

    ];

    const connectedIntegrations = integrations.filter(
        integration => integration.appInstalled
    );

    const availableIntegrations = integrations.filter(
        integration => !integration.appInstalled
    );

    return (

        <div className="overview-page">

            <MobileHeader />

            <Sidebar />

            <div className="overview-content">
                <div>
                    {data.message}
                </div>

                <Header
                    title="Integrations"
                    subtitle="Connect the platforms you already use."
                />

                <div className="integration-section">

                    <h2>Connected Integrations</h2>

                    <p>
                        This platform is connected to your account.
                    </p>

                    {connectedIntegrations.map((integration) => (

                        <IntegrationCard
                            key={integration.key}
                            integration={{
                                ...integration,
                                connectedDate: new Date(
                                    integration.installedAt
                                ).toLocaleDateString("en-US", {
                                    month: "long",
                                    day: "numeric",
                                    year: "numeric",
                                }),
                            }}
                            connected
                        />

                    ))}

                </div>

                {/* Available Integration continues in Part 2 */}

                <div className="integration-section">

                    <h2>Available Integrations</h2>

                    <p>
                        Connect more platforms to expand your reach.
                    </p>

                    {availableIntegrations.map((integration) => (

                        <IntegrationCard
                            key={integration.key}
                            integration={integration}
                        />

                    ))}

                </div>

                <div className="integration-security-banner">

                    <div className="integration-security-left">

                        <div className="integration-security-icon">

                            <Shield size={28} />

                        </div>

                        <div>

                            <h3>

                                Your data is safe and secure

                            </h3>

                            <p>

                                We use industry-standard encryption and follow best
                                practices to keep your data protected.

                            </p>

                        </div>

                    </div>

                    <button className="text-button">

                        Learn more

                        <ExternalLink size={16} />

                    </button>

                </div>

            </div>

        </div>

    );

}